import { Component, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, Input } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { PublicationService } from '../../services/publication.service';
import { Publication } from '../../interfaces/publication';
import { OverlayService, ModalDefinition } from '../../services/overlay.service';
import { User } from '../../interfaces/user';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BbAbstractMenuComponent } from '../shared/bb-abstract-menu/bb-abstract-menu.component';
import { MenuService } from '../../services/menu.service';
import { LocationService } from '../../services/location.service';

declare let window: any;

@Component({
	selector: 'bb-user-menu',
	templateUrl: './bb-user-menu.component.html',
	styleUrls: ['./bb-user-menu.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class BbUserMenuComponent extends BbAbstractMenuComponent implements OnInit {
	@Output() showUserMenu: EventEmitter<boolean>;

	publication: Publication;
	userInfo: User;
	displayName: string;
	switchToUser: string;
	globalLogin: boolean;
	hasPublication: boolean;
	showPublications: boolean;
	doublePublicationLink: boolean;
	publicationId: string;
	openMenu: string;

	constructor(
		private authenticationService: AuthenticationService,
		private locationService: LocationService,
		private publicationService: PublicationService,
		private overlayService: OverlayService,
		private translateService: TranslateService,
		private menuService: MenuService,
		private changeDetector: ChangeDetectorRef,
		protected router: Router) {

		super(['publication']);

		this.globalLogin = false;
		this.hasPublication = false;
		this.showPublications = false;
		this.doublePublicationLink = false;

		this.showUserMenu = new EventEmitter<boolean>();
		this.globalLogin = this.locationService.getGlobalLogin();

		this.authenticationService.getUser().subscribe((userInfo: User) => {
			this.userInfo = userInfo;
			this.displayName = '';
			if (this.userInfo && this.userInfo.name) {
				this.displayName = userInfo.name;
			}
			if (userInfo
				&& this.authenticationService.hasPermission('publicationconfig')
				&& this.authenticationService.hasPermission('usermanagement')) {

				this.doublePublicationLink = true;
			}
			if (userInfo && userInfo.id === '0') {
				this.doublePublicationLink = true;
			}
		});

		this.publicationService.getData().subscribe((publication: Publication) => {
			this.publication = publication;
			if (this.publication) {
				this.publicationId = publication.id;

				this.hasPublication = true;
			} else {
				this.hasPublication = false;
			}
		});
	}

	ngOnInit() {
		this.subscriptions.add(this.router.events.subscribe((routerEvent: RouterEvent) => {
			if (routerEvent instanceof NavigationEnd) {
				this.changeDetector.detectChanges();
			}
		}));
	}

	hidePublicationsMenu() {
		this.showPublications = false;
	}

	switchUser() {
		this.authenticationService.switchToUser(this.switchToUser).subscribe((switched: boolean) => {
			if (switched) {
				location.reload();
			}
		});
	}

	logout() {
		this.authenticationService.logout().subscribe();
	}

	switchPublication(publication: Publication) {
		if (publication && publication.name) {
			this.authenticationService.switchToPublication(publication.name, true).subscribe();

			const msg = this.translateService.instant('PUBLICATION_SWITCHED', { publication: (publication.label || publication.name) });
			this.overlayService.createToast(msg, 'database');
		} else {
			if (this.publication) {
				// Go to global
				const target = this.publication.baseurl.replace(this.publication.name + '.', '');
				window.location = target;
			}
		}
	}

	setOpenMenu(openMenu: string) {
		this.openMenu = openMenu;
	}

	hideUserMenu() {
		this.menuService.hideMobileMenu();
	}

	hideMenu(event: Event) {
		const element: HTMLElement = (event.target as HTMLElement);

		if (element.tagName.toLowerCase() === 'a' && !element.getAttribute('do-not-close-menu')) {
			this.showUserMenu.emit(false);
		}
	}

	showAbout() {
		const modal: ModalDefinition = {
			icon: '',
			title: '',
			component: { name: 'bb-about' }
		};

		this.overlayService.createModal(modal);
	}
}
